(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/nav-context/assets/javascripts/nav-context-provider.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/nav-context/assets/javascripts/nav-context-provider.js');
"use strict";


const {
  useLocation,
  matchPath
} = ReactRouterDOM;
const {
  useEffect,
  useState
} = React;
const {
  NavContext
} = svs.oddset_kambi.components.nav_context;
const getCurrentRoute = (routes, activePathname) => routes.find(route => matchPath(activePathname, {
  path: "/".concat(route.path)
}));
const NavContextProvider = _ref => {
  let {
    children
  } = _ref;
  const routes = svs.oddset_kambi.data.tabsConfig;
  const playRoute = svs.oddset_kambi.data.tabsConfigPlay;
  const location = useLocation();
  const [activePathname, setActivePathname] = useState(location.pathname);
  const [windowLocationPathname, setWindowLocationPathname] = useState(window.location.pathname);
  useEffect(() => {
    setWindowLocationPathname(window.location.pathname); 
  }, [window.location.pathname]);
  useEffect(() => {
    setActivePathname(location.pathname);
  }, [location.pathname]);
  return React.createElement(NavContext.Provider, {
    value: {
      activePathname,
      setActivePathname,
      currentRoute: getCurrentRoute([...routes, playRoute], activePathname),
      windowLocationPathname
    }
  }, children);
};
setGlobal('svs.oddset_kambi.components.nav_context.NavContextProvider', NavContextProvider);

 })(window);